module.exports = __webpack_public_path__ + "static/media/finMagic_logo.759a53d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/finMagic_logo.svg
// module id = 298
// module chunks = 21